import React from "react";
import { UserList } from "./UserList";

interface UserSelectionPanelProps {
  title: string;
  selectedCount: number;
  searchTerm: string;
  onSearchChange: (term: string) => void;
  users: any[];
  loading: boolean;
  selectedIds: string[];
  onSelectUser: (userId: string) => void;
  onClearAll: () => void;
  onSwitchToBroadcast: () => void;
  broadcastButtonText: string;
}

export const UserSelectionPanel: React.FC<UserSelectionPanelProps> = ({
  title,
  selectedCount,
  searchTerm,
  onSearchChange,
  users,
  loading,
  selectedIds,
  onSelectUser,
  onClearAll,
  onSwitchToBroadcast,
  broadcastButtonText,
}) => (
  <div className="p-6 bg-white rounded-lg shadow-md lg:col-span-1">
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-lg font-semibold">{title}</h3>
      {selectedCount > 0 && (
        <span className="px-3 py-1 text-sm font-semibold text-green-700 bg-green-100 rounded-full">
          {selectedCount} sélectionné{selectedCount > 1 ? "s" : ""}
        </span>
      )}
    </div>

    <input
      type="text"
      placeholder="Rechercher par nom, email ou téléphone..."
      value={searchTerm}
      onChange={(e) => onSearchChange(e.target.value)}
      className="px-4 py-2 mb-4 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-green-500"
    />

    <UserList
      users={users}
      loading={loading}
      searchTerm={searchTerm}
      selectedIds={selectedIds}
      onSelect={onSelectUser}
      multiple={true}
    />

    <div className="pt-4 mt-4 space-y-2 border-t">
      {selectedCount > 0 && (
        <button
          onClick={onClearAll}
          className="px-4 py-2 w-full text-sm font-medium text-gray-700 bg-gray-200 rounded-lg transition-colors hover:bg-gray-300"
        >
          Désélectionner tout
        </button>
      )}
      <button
        onClick={onSwitchToBroadcast}
        className="px-4 py-2 w-full font-medium text-white bg-blue-600 rounded-lg transition-colors hover:bg-blue-700"
      >
        {broadcastButtonText}
      </button>
    </div>
  </div>
);
